import { formatMoney, formatUnitPrice } from '../../../utils/money';
import { localeForLanguage } from '../../../utils/numberFormatting';

/** Readout number: localized, up to `maxDigits` decimals, no forced zeros. */
export function formatReadout(value: number | null | undefined, maxDigits = 2, language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString(localeForLanguage(language), { maximumFractionDigits: maxDigits });
}

/** PLN amount with the currency sign used on the product card. */
export function formatZloty(value: number | null | undefined, language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return `${formatMoney(value, language)} zł`;
}

/** Unit cost (2–4 decimals, trailing zeros trimmed) with the currency sign. */
export function formatUnitZloty(value: number | null | undefined, language = 'pl'): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return `${formatUnitPrice(value, language)} zł`;
}
